import { render, staticRenderFns } from "./ProcessMonitor.vue?vue&type=template&id=061620d4"
import script from "./ProcessMonitor.vue?vue&type=script&lang=js"
export * from "./ProcessMonitor.vue?vue&type=script&lang=js"
import style0 from "./ProcessMonitor.vue?vue&type=style&index=0&id=061620d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports